import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { TextField } from "@mui/material";
import { Grid } from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import _ from "underscore";
import "./style.css";
import { API_BASE_URL, EDIT_LANDED_COST_TABLE_API, BUILK_EDIT_MEDIUM_HOME_LANDEDCOST_UPDATEBYIDS } from "../../../Utils/Config";
import { EditProductTableError, EditProductTableStart, EditProductTableSuccess, openErrorDialog } from "../../../Redux/Actions/InputData";
import { putRequest } from "../../../Services/AxiosConfiguration";
import { useState } from "react";
import { useForm } from "react-hook-form";

const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function EditModal(props: any) { 
    const { editedData } = props;
    const dispatch: any = useDispatch();
    const [isDone, setIsDone] = useState(false);

    const handleCloseDonePopup = () => {
      editedData.landed_Cost = props?.resetValues?.landed_Cost;
      props.onClose();
      // setIsDone(false);
      // dispatch(cloaseDonePopup());
    };

    const validationSchema = Yup.object().shape({
        landed_Cost: Yup.string().required('Landed Cost is required')
        // ,
        // conversion_Cost_CPT: Yup.string().required('Conversion Cost CPT is required')
    });

    const { register, control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = () => {
        // const requestParam = { "table": "Manufacturing_data", "id": data.id, "values": { "OEE": data["OEE "], "Conversion Cost/CPT": data["Conversion Cost/CPT"] } };
        dispatch(EditProductTableStart());
        const urls = API_BASE_URL + BUILK_EDIT_MEDIUM_HOME_LANDEDCOST_UPDATEBYIDS;
        const header = { accept: "application/json", "Content-Type": "application/json" };
        putRequest(urls, editedData, header, {}).then((response) => {
            if (response.status === 200) {
                dispatch(EditProductTableSuccess(response.data));
            }
        }).catch((error) => {
            dispatch(openErrorDialog(error));
            dispatch(EditProductTableError(error));
        });
        setTimeout(() => {
            props.onClose();
        }, 200);
    };
    return (
      <>
        <BootstrapDialog
          className="edit-dialog"
          onClose={props.onClose}
          aria-labelledby="customized-dialog-title"
          open={props.isOpen}
        >
          <div className="modal-header">
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h3>{props.headerName}</h3>
                <span className="title-note">Edit table content</span>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <CancelIcon className="cancel-icon" onClick={props.onClose} />
              </Grid>
            </Grid>
          </div>
          <div>
            <DialogContent className="modal-body">
              <form>
                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6} md={6} lg={6}>
                    <TextField
                      type="text"
                      label="Factory"
                      variant="outlined"
                      defaultValue={editedData.factory}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6} md={6} lg={6}>
                    <TextField
                      type="text"
                      label="Factory Code"
                      variant="outlined"
                      defaultValue={editedData.factory_Code}
                      disabled
                    />
                  </Grid>
                </Grid>

                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Base Pack"
                      variant="outlined"
                      defaultValue={editedData.basepack}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Base Pack Code"
                      variant="outlined"
                      defaultValue={editedData.basepack_Code}
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6} md={6} lg={6} >
                    <TextField
                      type="text"
                      label="Time Period"
                      variant="outlined"
                      defaultValue={editedData.time_period}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField onKeyDown={(evt) => ["e", "E", "+"].includes(evt.key) && evt.preventDefault()}
                      type="number"
                      label="Landed Cost"
                      variant="outlined"
                      {...register("landed_Cost")}
                      required
                      error={errors.landed_Cost ? true : false}
                      defaultValue={editedData.landed_Cost}
                      onChange={(e) => (editedData.landed_Cost = e.target.value)}
                    />
                  </Grid>
                  {/* <Grid container item sm={6} md={6} lg={6}>
                    <TextField
                      type="text"
                      label="Landed Cost"
                      variant="outlined"
                      defaultValue={editedData.landed_Cost}
                      disabled
                    />
                  </Grid> */}
                </Grid>
                <Grid direction="row" container spacing={2} mb={2}>
                <Grid container item sm={6}>
                    <div className="error-msg">
                      {errors.landed_Cost ? "Invalid Landed Cost" : false}
                    </div>
                  </Grid>
                  </Grid>
                {/* <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="OEE"
                      variant="outlined"
                      {...register("oee")}
                      required
                      error={errors.oee ? true : false}
                      defaultValue={editedData.oee}
                      onChange={(e) => (editedData.oee = e.target.value)}
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Conversion Cost CPT"
                      variant="outlined"
                      {...register("conversion_Cost_CPT")}
                      required
                      error={errors.conversion_Cost_CPT ? true : false}
                      defaultValue={editedData.conversion_Cost_CPT}
                      onChange={(e) =>
                        (editedData.conversion_Cost_CPT = e.target.value)
                      }
                    />
                  </Grid>
                </Grid> 
                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <div className="error-msg">
                      {errors.landed_Cost ? "Invalid Landed Cost" : false}
                    </div>
                  </Grid>
                   <Grid container item sm={6}>
                    <div className="error-msg">
                      {errors.conversion_Cost_CPT
                        ? "Invalid Conversion Cost CPT"
                        : false}
                    </div>
                  </Grid> 
                </Grid>
*/}
                {/* <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Factory Code"
                      variant="outlined"
                      defaultValue={editedData.factory_code}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Format"
                      variant="outlined"
                      defaultValue={editedData.format}
                      disabled
                    />
                  </Grid>
                </Grid> */}
              </form>
            </DialogContent>
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={handleCloseDonePopup}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="save"
                  onClick={handleSubmit(onSubmit)}
                >
                  Save Table Row
                </Button>
                {/* <Button variant="contained" className="save" onClick={(e) => { handleSave(editedData, props); }}>Save Table Row</Button> */}
              </div>
            </DialogActions>
          </div>
        </BootstrapDialog>
      </>
    );
}

export default EditModal;
